import React from 'react';

import styles from './styles.module.scss';

export const SubContentComponent: React.FC<sharedComponents.SubContentComponent> = ({
  title,
  className,
  children,
  additionalTitleComponent,
}) => (
  <div className={className}>
    <p className={styles.title}>{title}{additionalTitleComponent}</p>
    {children}
  </div>
);
